<template>
    <div>
        <div class="content-box p-5">
            <div class="page-top mb-1 mb-3 clearfix">
                <ul class="nav nav-tabs nav-tabs-1 float-left" id="myTab" role="tablist">
                    <li class="nav-item">
                        <a aria-controls="active" aria-selected="true" class="nav-link active" data-toggle="tab"
                           href="#submit-complaint"
                           id="submit-complaint-tab" role="tab">Submit Complaint</a>
                    </li>
                    <li class="nav-item">
                        <a aria-controls="deleted" aria-selected="false" class="nav-link" data-toggle="tab"
                           href="#complaint-history"
                           id="complaint-history-tab" role="tab">Complaint History</a>
                    </li>
                </ul>
            </div>
            <div class="tab-content" id="myTabContent">
                <div aria-labelledby="submit-complaint-tab" class="tab-pane fade show active" id="submit-complaint"
                     role="tabpanel">
                    <div class="px-5 mx-5 contact-main">
                        <div class="contact-head">
                            <div class="contact-icon">
                                <img :src="`/images/svgs/help-icon.svg`" alt="Help">
                            </div>
                            <h3 class="text-center mb-3">We're here to help</h3>
                        </div>
                        <form @submit.prevent="addEnquiry" id="enquiry">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <input :class="{ 'is-invalid': form.errors.has('fullname') }" :disabled="true"
                                               class="form-control"
                                               id="fullname" name="fullname" placeholder="Customer Name *"
                                               type="text" v-model="fullname"/>
                                        <has-error :form="form" field="fullname"></has-error>
                                    </div>
                                </div>

                                <div class="col-md-12">
                                    <div class="form-group">
                                        <input :class="{ 'is-invalid': form.errors.has('customer_details') }"
                                               class="form-control"
                                               name="customer_details"
                                               placeholder="Subject *"
                                               type="text"
                                               v-model="form.customer_details"/>
                                        <has-error :form="form" field="customer_details"></has-error>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                    <textarea :class="{ 'is-invalid': form.errors.has('message') }" class="form-control" id="message"
                              name="message" placeholder="Message *"
                              rows="2" v-model="form.message"></textarea>
                                        <has-error :form="form" field="message"></has-error>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <select :class="{ 'is-invalid': form.errors.has('purpose') }" class="selectpicker custom-select2"
                                                id="purpose"
                                                name="purpose"
                                                placeholder="Purpose" v-model="form.purpose">
                                            <option selected value=""> select Complaint type *</option>
                                            <option value="FEEDBACK">Feedback</option>
                                            <option value="HELP">Help</option>
                                            <option value="INQUIRY">Inquiry</option>
                                            <option value="COMPLAINT">Complaint</option>
                                            <option value="OTHER">Other</option>
                                        </select>
                                        <has-error :form="form" field="purpose"></has-error>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <select :class="{ 'is-invalid': form.errors.has('priority') }"
                                                class="selectpicker custom-select2"
                                                name="priority"
                                                placeholder="Priority" v-model="form.priority">
                                            <option selected value="">Select Priority *</option>
                                            <option value="Low">Low</option>
                                            <option value="Medium">Medium</option>
                                            <option value="High">High</option>
                                        </select>
                                        <has-error :form="form" field="priority"></has-error>
                                    </div>
                                </div>
                            </div>
                            <div style="padding: 30px; border: #f0f1f3 dashed 2px;">
                                <div class="col-md-12" style="display: flex; justify-content: center">
                                    <div>
                                        <label for="fileInput">
                                            <div class="d-flex align-items-center flex-column cursor-pointer"
                                                 v-if="selectedFiles.length === 0">
                                                <img alt="" class="upload" for="file" id="uploadIcon"
                                                     src="/images/svgs/upload-icon.svg"><br/>
                                                <span style="font-size: 20px">Drop files here or click to upload.</span>
                                            </div>
                                            <input @change="handleFileChange" accept="image/*, application/pdf" id="fileInput"
                                                   multiple
                                                   style="display: none" type="file"/>
                                        </label>
                                        <div v-if="selectedFiles.length">
                                            <div :key="index" v-for="(file, index) in selectedFiles">
                                                <template v-if="file.type.startsWith('image/')">
                                                    <img :alt="'Selected Image ' + (index + 1)" :src="file.url"
                                                         style="width: 69px; height: 69px"/>
                                                </template>
                                                <template v-else>
                                                    <embed :src="file.url" height="200" type="application/pdf"
                                                           width="200"/>
                                                </template>
                                                <span>Selected File: {{ file.name }}</span>
                                                <img @click="removeFile(index)" alt="Remove File"
                                                     class="remove-icon cursor-pointer"
                                                     src="/images/cross.png"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex justify-content-end mt-3" style="gap: 10px">
                                <router-link class="btn btn-primary float-right mr-1" to="/"> Cancel</router-link>
                                <input class="btn btn-primary submitted active" disabledOnClicked id="#" type="submit"
                                       value="Submit">
                            </div>
                        </form>
                        <div class=" mt-5 d-flex justify-content-center">
                            <h2> Need Further assistance ?</h2>
                        </div>
                        <div class="d-flex justify-content-center mt-3">
                            <div class="d-flex" style="gap:36px">
                                <div>
                                    <img alt="image" src="/images/mail-fill.png"/>
                                    <span>{{ this.email? this.email:""}}</span>
                                </div>
                                <div>
                                    <img alt="" src="/images/phone.png"/>
                                    <span>{{ this.phone? this.phone:"" }}</span>
                                </div>
                                <div>
                                    <img alt="image" src="/images/office hours.png" width="24px"/>
                                    <span>10AM to 6PM</span>
                                </div>
                            </div>
                        </div>
                        <hr/>
                        <div class="d-flex justify-content-center">
                            <div class="d-flex" style="gap:12px">
                                <a href="https://www.instagram.com/finja.pk/" target="_blank"><img alt="image"
                                                                                                   src="/images/instagram.png"/></a>
                                <a href="https://www.linkedin.com/company/finja/mycompany/" target="_blank"><img
                                        alt="image" src="/images/linkedin.png"/></a>
                                <a href="https://www.facebook.com/finja.pk" target="_blank"><img alt="image"
                                                                                                 src="/images/facebook.png"/></a>
                                <a href="https://finjabusiness.pk/" target="_blank"> <img alt="image"
                                                                                          src="/images/website.png"/></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div aria-labelledby="complaint-history-tab" class="tab-pane fade" id="complaint-history"
                     role="tabpanel">
                    <ComplaintHistory></ComplaintHistory>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

    export default {
        data() {
            return {
                form: new Form({
                    custoer_details: '',
                    message: '',
                    purpose: '',
                    priority: '',
                    complaint: '',
                }),
                fullname: '',
                email:"",
                phone:"",
                selectedFile: null,
                selectedFiles: [],
                isImage: false,
                complaintSubmitted: false,
                sales_team_list: '',
            };
        },
        mounted() {
            $('.selectpicker').selectpicker('refresh');
            this.tablelist()
        },
        methods: {
            addEnquiry: function () {
                $('.submitted').prop('disabled', true);
                const formData = new FormData();
                formData.append('fullname', this.fullname);
                formData.append('customer_details', this.form.customer_details);
                formData.append('message', this.form.message);
                formData.append('purpose', this.form.purpose);
                formData.append('priority', this.form.priority);
                formData.append('complaint', this.form.complaint)

                this.$Progress.start();
                axios.post('api/addEnquiry', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                })
                    .then((res) => {
                        if (res.status === 200) {
                            this.$Progress.finish();
                            this.showToastBox(
                                'success',
                                'Your Complaint has been submitted successfully'
                            );
                            $('#complaint-history-tab').tab('show');
                            this.form.fullname = '';
                            this.form.customer_details = '';
                            this.form.message = '';
                            this.form.purpose = '';
                            this.form.priority = '';
                            this.form.complaint = '';
                            this.selectedFiles = [];
                            this.complaintSubmitted = true;
                            $('#complaintTable').DataTable().ajax.reload()
                            $('.submitted').prop('disabled', false);
                            $(this.$el).find('.selectpicker').selectpicker('refresh');
                        } else {
                            $(this.$el)
                                .find('.selectpicker')
                                .selectpicker('refresh');
                            $('.submitted').prop('disabled', false);
                            this.$Progress.fail();
                            this.showAlertBox('error', 'Some problem in your form data');
                        }
                    })
                    .catch((errors) => {
                        $(this.$el)
                            .find('.selectpicker')
                            .selectpicker('refresh');
                        $('.submitted').prop('disabled', false);
                        this.$Progress.fail();
                        const errorMessages = Object.entries(errors.response.data.errors)
                            .map(([field, messages]) => `${field}: ${messages.join(', ')}`)
                            .join('\n');
                        this.showAlertBox('error', `Validation errors:\n${errorMessages}`);
                    });
            },
            handleFileChange(event) {
                const files = event.target.files;
                if (files.length > 0) {
                    this.form.complaint = event.target.files[0];
                    this.selectedFiles = Array.from(files).map(file => ({
                        name: file.name,
                        url: URL.createObjectURL(file),
                        type: file.type,
                    }));
                }
            },
            removeFile(index) {
                this.selectedFiles.splice(index, 1);
                this.form.complaint = ''
            },
            tablelist() {
                this.$Progress.start();
                axios.get('/api/inquiry')
                    .then(res => {
                        this.$Progress.finish();
                        this.fullname = res.data.current_user
                        this.email = res.data.sales_email.value
                        this.phone = res.data.sales_number.value
                        this.$Progress.finish();
                    }).then(res => {
                    $('.selectpicker').selectpicker();
                }).catch(err => {
                    console.log(err);
                });
            },
        },
    };
</script>
